// for removing underscore in type sent back
export const removeUnderscore = (key) => key.split('_').join(' ');

// for filtering out missing medians
export const removeMissingMedians = ({ median }) =>
    median !== '?' && median !== '0';

// for constructing the x weeks of type
export const constructDescription = ({ type, median }) =>
    `${median} ${pluralizeWeeks(median)} of ${removeUnderscore(type)} leave`;

// join descriptions by comma or 'and'
export const joinByCommaOrAnd = (
    concatenatedString,
    currentString,
    index,
    filteredArray
) => {
    let separator = ', ';

    if (index === 0) {
        separator = '';
    } else if (index >= filteredArray.length - 1) {
        separator = ' and ';
    }

    return concatenatedString + separator + currentString;
};

// pluralize week depending on argument sent in
export const pluralizeWeeks = (weeks) => (weeks === '1' ? 'week' : 'weeks');
